import ContractTypeBaseController from "../common/contract_type.base.controller";

class ContractTypeCreateController extends ContractTypeBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, ContractTypeService) {

        super(Auth, $state, User, ContractTypeService, Modal, $translate, $stateParams)
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.ContractTypeService = ContractTypeService;

        this.defaultModel = {
            type: null,
            description: null,
        }
        
        this.model = angular.copy(this.defaultModel)
    }

    $onInit() {}

    submit() {
        this.model.isCreate = true;
        delete this.model.errorMessage;

        this.Service.create({
            type: this.model.type,
            description: this.model.description,
        })
            .then(() => {
                this.askCreate();
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isCreate = false;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }
}

export default ContractTypeCreateController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/create/contract_type.create.controller.js